import React, { useEffect, useState } from 'react';
import { useToasts } from "react-toast-notifications";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import Table from "react-bootstrap/Table";
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "../../styles.css";

const TemplatesModal = ({ modalTitle = "", show, setShow, onSelectTemplate, onDeleteTemplate, setTemplates, templates, refetch }) => {
    const { addToast } = useToasts();
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [orderBy, setOrderBy] = useState({
        header: 'name',
        isDesc: true
    });

    useEffect(() => {
        if (show) {
            handleGetTemplates(orderBy.header, orderBy.isDesc);
        }
    }, [show]);

    const handleGetTemplates = (header, isDesc) => {
        axios.post('/api/administration/templates', {
            header: header,
            isDesc: isDesc
        }).then(res => {
            const templates = res.data.templates;
            setTemplates(templates);
        })
            .catch(err => {
                console.log(err);
                addToast('Unable to fetch templates!', { appearance: 'error', autoDismiss: true });
            });
    };

    const handleSelect = () => {
        onSelectTemplate(selectedTemplate);
        setShow(false);
    };

    const handleDelete = () => {
        onDeleteTemplate(selectedTemplate);
        handleGetTemplates(orderBy.header, orderBy.isDesc);
    };

    const handleOrderBy = (header, isDesc) => {
        setOrderBy({
            ...orderBy,
            header: header,
            isDesc: !isDesc
        });
        handleGetTemplates(header, !isDesc);
    };

    return (
        <Modal dialogClassName="templates-modal" className="alert-confirm-modal" centered show={show} onHide={() => setShow(false)} scrollable={true}>
            {modalTitle &&
                <Modal.Header closeButton style={{ borderBottomColor: 'transparent' }}>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
            }
            <Modal.Body style={{ paddingTop: 0 }}>
                <div
                    className="d-flex flex-row align-items-center justify-content-center border-top"
                    style={{ padding: '15px', position: 'sticky', top: 0, background: '#fff' }}
                >
                    <Button onClick={handleSelect} variant="primary" className="mt-0" disabled={!selectedTemplate}>Select</Button>
                    <Button onClick={handleDelete} variant="danger" className="mt-0" disabled={!selectedTemplate}>Delete</Button>
                </div>
                <Table responsive hover>
                    <thead>
                        <tr>
                            <th className="text-left" style={{ width: '42%' }}>
                                <a
                                    className="d-flex flex-row align-items-center"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleOrderBy('name', orderBy.header == 'name' ? orderBy.isDesc : !orderBy.isDesc);
                                    }}
                                >
                                    <span className="mr-2" style={{ color: 'black' }}>Name</span>
                                    {orderBy.header === 'name' && (
                                        <div className="d-flex flex-column">
                                            <FontAwesomeIcon icon={["fas", orderBy.isDesc ? "chevron-down" : "chevron-up"]} color="#0097FE" />
                                        </div>
                                    )}
                                </a>
                            </th>
                            <th style={{ width: '18%' }}>
                                <a
                                    className="d-flex flex-row align-items-center"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleOrderBy('modify_at', orderBy.header == 'modify_at' ? orderBy.isDesc : !orderBy.isDesc);
                                    }}
                                >
                                    <span className="mr-2" style={{ color: 'black' }}>Modified</span>
                                    {orderBy.header === 'modify_at' && (
                                        <div className="d-flex flex-column">
                                            <FontAwesomeIcon icon={["fas", orderBy.isDesc ? "chevron-down" : "chevron-up"]} color="#0097FE" />
                                        </div>
                                    )}
                                </a>
                            </th>
                            <th style={{ width: '18%' }}>
                                <a
                                    className="d-flex flex-row align-items-center"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleOrderBy('date_sent', orderBy.header == 'date_sent' ? orderBy.isDesc : !orderBy.isDesc);
                                    }}
                                >
                                    <span className="mr-2" style={{ color: 'black' }}>Last Sent</span>
                                    {orderBy.header === 'date_sent' && (
                                        <div className="d-flex flex-column">
                                            <FontAwesomeIcon icon={["fas", orderBy.isDesc ? "chevron-down" : "chevron-up"]} color="#0097FE" />
                                        </div>
                                    )}
                                </a>
                            </th>
                            <th style={{ width: '18%' }}>
                                <a
                                    className="d-flex flex-row align-items-center"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleOrderBy('sus_sent', orderBy.header == 'sus_sent' ? orderBy.isDesc : !orderBy.isDesc);
                                    }}
                                >
                                    <span className="mr-2" style={{ color: 'black' }}>#SUs Sent</span>
                                    {orderBy.header === 'sus_sent' && (
                                        <div className="d-flex flex-column">
                                            <FontAwesomeIcon icon={["fas", orderBy.isDesc ? "chevron-down" : "chevron-up"]} color="#0097FE" />
                                        </div>
                                    )}
                                </a>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {templates.map((template, index) => {
                            return (
                                <tr key={index} onClick={() => setSelectedTemplate(template)} role="button">
                                    <td className="text-left">
                                        <input
                                            type="radio"
                                            value={selectedTemplate || ''}
                                            checked={selectedTemplate && selectedTemplate.id === template.id}
                                            onChange={() => setSelectedTemplate(template)}
                                            className="mr-2"
                                        />
                                        {template.name}
                                    </td>
                                    <td className="text-secondary text-left">
                                        {template.modify_at ? moment(template.modify_at, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''}
                                    </td>
                                    <td className="text-secondary text-left">
                                        {template.date_sent ? moment(template.date_sent, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''}
                                    </td>
                                    <td className="text-secondary text-center">
                                        {template.sus_sent}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
                <div
                    className="d-flex flex-row align-items-center justify-content-center border-top"
                    style={{ paddingTop: 15, marginTop: -15 }}
                >
                    <Button onClick={handleSelect} variant="primary" className="mt-0" disabled={!selectedTemplate}>Select</Button>
                    <Button onClick={handleDelete} variant="danger" className="mt-0" disabled={!selectedTemplate}>Delete</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};
export default TemplatesModal;